var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.555,
    height: 60.785,
    viewBox: "0 0 213.555 60.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "83b9rck52a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    style: {
      fill: "none"
    },
    d: "M0 0h213.555v60.785H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4",
    style: {
      clipPath: "url(#83b9rck52a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "M272.974 18.082a15.816 15.816 0 0 1 9.9-3.3q6.928 0 11.095 4.408a15.605 15.605 0 0 1 4.168 11.166 15.589 15.589 0 0 1-4.95 11.945 14.643 14.643 0 0 1-21.368-1.072 16.424 16.424 0 0 1-4.289-11.2q0-7.747 5.444-11.948m-11.566 33.796a28.935 28.935 0 0 0 21.47 8.908q13.461 0 22.13-9.4a29.888 29.888 0 0 0 8.174-21.032 29.556 29.556 0 0 0-8.671-21.524A28.889 28.889 0 0 0 283.043 0Q269 0 260.335 9.814a29.294 29.294 0 0 0-7.68 20.041 30.193 30.193 0 0 0 8.753 22.022",
    transform: "translate(-128.4)",
    style: {
      fill: "#ef5713"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "m368.369 61.36-9.889-14.68v14.68h-6.39V35.021h5.872l9.667 14.642V35.021h6.39V61.36z",
    transform: "translate(-178.932 -17.798)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "M411.568 55.574h7.868v5.786h-14.317V35.021h14.318v5.786h-7.868v4.3h7.868v5.842h-7.868z",
    transform: "translate(-205.882 -17.798)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M24.549 42.107h-2.993a14.348 14.348 0 0 0-3.386-3.267 8.884 8.884 0 0 0-4.884-1.363 10.142 10.142 0 0 0-7.8 3.277 10.419 10.419 0 0 0-2.781 7.3 10.748 10.748 0 0 0 3.013 7.714 9.78 9.78 0 0 0 7.358 3.15 9.64 9.64 0 0 0 4.241-.878 12.6 12.6 0 0 0 4.1-3.41l2.922-.021a11.916 11.916 0 0 1-4.489 4.915 12.331 12.331 0 0 1-6.628 1.83 14.172 14.172 0 0 1-8.443-2.671 10.9 10.9 0 0 1-4.667-9.4c0-.214-.019-.5-.054-.858S0 47.885 0 47.863a12.711 12.711 0 0 1 3.137-8.371 12.416 12.416 0 0 1 10.01-4.451 12.327 12.327 0 0 1 7.2 2.177 12.925 12.925 0 0 1 4.2 4.89",
    transform: "translate(0 -17.807)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 17",
    d: "M66.737 51.156h-9.6L61.9 38.419zm3.888 10.265 2.612.008-9.726-25.311h-2.992l-9.7 25.352 2.558-.005 3.069-7.978h11.072z",
    transform: "translate(-25.826 -18.355)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18",
    d: "M103.512 38.553h1.39q4.063 0 5.7 1.251a4.05 4.05 0 0 1 1.426 3.462 4.785 4.785 0 0 1-1.441 3.693 6.522 6.522 0 0 1-4.543 1.338h-3.6v-9.744zm.286 12.234q5.922 0 8.633-1.954a5.793 5.793 0 0 0 2.352-5.008q0-4.193-2.46-6.075-2.139-1.633-6.522-1.632h-5.846V61.43h2.488V50.788z",
    transform: "translate(-50.797 -18.356)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 4",
    transform: "translate(67.398 17.763)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.541v25.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 19",
    d: "M160.008 38.607h-4.978V61.43h-2.542V38.607H147.4v-2.488H160z",
    transform: "translate(-74.911 -18.356)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 20",
    d: "M187.717 51.156h-9.6l4.763-12.738zm3.89 10.265 2.612.008-9.728-25.311H181.5l-9.7 25.352 2.555-.005 3.071-7.978H188.5z",
    transform: "translate(-87.309 -18.355)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 21",
    d: "M224.016 59h8.917v2.43h-11.458V36.118h2.541z",
    transform: "translate(-112.554 -18.355)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d141d7edf9ed50f19da136964d0c4e16.svg";
export { ForwardRef as ReactComponent };